<template>
	<div class="result-dialog">
		<img src="~@/assets/pass.png" alt="" />
		<p class="score-text" v-if="$route.query.score">{{ $route.query.score }}分</p>
		<p class="result-text">恭喜您，考试通过！</p>
		<!-- <p>请登录华培网查看证书信息</p> -->
		<div class="btn" @click="confirmDialog">确认</div>
	</div>
</template>

<script>
export default {
	props: {
		mode: {
			type: String,
			default: 'exam'
		}
	},
	data() {
		return {};
	},
	created() {
		if (!this.$store.getters.getToken) {
			this.navToForbidden();
		}
	},
	methods: {
		navToForbidden() {
			this.$router.replace({
				path: '/' + this.mode + '/login'
			});
		},
		// 点击确定 - 关闭弹层
		confirmDialog() {
			if (this.$store.getters.isPc) {
				// pc端退回首页
				this.$router.replace({
					path: '/'
				});
			} else {
				// 手机端跳转至登录
				this.$store.dispatch('logout');
				this.$router.replace({
					path: '/exam/login'
				});
			}
		}
	}
};
</script>

<style lang="less" scoped>
// 考试结果弹窗
.result-dialog {
	width: 10rem;
	text-align: center;
	img {
		margin-top: 3.2rem;
		width: 3.493rem;
		height: 3.493rem;
	}
	.score-text {
		margin-top: 0.733rem;
		font-size: 0.8rem;
		font-weight: bold;
		color: #34c144;
	}
	.result-text {
		margin-top: 0.533333rem;
		font-size: 0.48rem;
		font-weight: bold;
		color: #0f0e0e;
		line-height: 1;
	}
	.tips-text {
		margin-top: 0.533333rem;
		font-size: 0.373333rem;
		color: #666;
		line-height: 1;
	}
	.btn {
		height: 1.147rem;
		margin: 1.533rem 0.627rem 0;
		line-height: 1.147rem;
		background: linear-gradient(-90deg, #0ea5a5, #13afaf);
		border-radius: 0.133rem;
		font-size: 0.4rem;
		font-weight: 400;
		color: #ffffff;
	}
}
</style>
